import findNotesUseCase from "../findNotesUseCase";
import addNoteUseCase from "../addNoteUseCase";
import toggleNoteUseCase from "../toggleNoteUseCase";
import deleteNoteUseCase from "../deleteNoteUseCase";
import editNoteUseCase from "../editNoteUseCase";

export const SET_ALL_DATA = "SET_ALL_DATA_NOTES";
export const SET_ITEM = "SET_ITEM_NOTE";
export const DELETE_ITEM = "DELETE_ITEM_NOTE";

const setAllData = (payload) => ({ type: SET_ALL_DATA, payload });
const setItem = (payload) => ({ type: SET_ITEM, payload });
const deleteItem = (payload) => ({ type: DELETE_ITEM, payload });

let unsubscribeNotes = null;

export const getNotes = () => {
  return async (dispatch, getState) => {
    // Evita duplicar listeners si se llama varias veces
    if (unsubscribeNotes) return;

    unsubscribeNotes = findNotesUseCase((snapshot) => {
      const { added, modified, removed } = getDataFromSnapshot(snapshot);

      if (Object.keys(getState().notes.data || {}).length === 0) {
        dispatch(setAllData(added));
      } else {
        Object.entries(added).forEach(([key, value]) =>
          dispatch(setItem({ id: key, data: value }))
        );
        Object.entries(modified).forEach(([key, value]) =>
          dispatch(setItem({ id: key, data: value }))
        );
        Object.entries(removed).forEach(([key]) =>
          dispatch(deleteItem({ id: key }))
        );
      }
    });
  };
};

export const stopNotesListener = () => {
  return () => {
    if (unsubscribeNotes) {
      unsubscribeNotes();
      unsubscribeNotes = null;
    }
  };
};

export const addNote = (text) => async () => {
  const value = (text || "").trim();
  if (!value) return;
  await addNoteUseCase(value);
};

export const toggleNote = (id, done) => async () => {
  await toggleNoteUseCase(id, done);
};

export const removeNote = (id) => async () => {
  await deleteNoteUseCase(id);
};

export const editNote = (id, text) => async () => {
  const value = (text || "").trim();
  if (!value) return;
  await editNoteUseCase(id, value);
};

const getDataFromSnapshot = (snapshot) => {
  let data = { added: {}, modified: {}, removed: {} };

  snapshot.docChanges().forEach((change) => {
    const type = data[change.type];
    type[change.doc.id] = applyTransformData(change.doc.data());
  });

  return data;
};

const applyTransformData = (note) => ({ ...note });